import { OktaAuth } from "@okta/okta-auth-js";
import config from "../../common/config";

let myMemoryStore = {};
export const storageProvider = {
  getItem: function(key) {
    return myMemoryStore[key];
  },
  setItem: function(key, val) {
    myMemoryStore[key] = val;
  },
  removeItem: function(key) {
    delete myMemoryStore[key];
  },
};

export const oktaAuth = !config.isLocalTestEnvironment()
  ? new OktaAuth({
    ...config.oktaConfig,
    tokenManager: {
      autoRenew: false,
      storage: storageProvider,
    },
    transactionManager: {
      saveNonceCookie: false,
      saveStateCookie: false,
      saveParamsCookie: false,
    },
  })
  : null;

export const oktaAccessTokenObject = () => {
  const tokensObjectAsStr = storageProvider.getItem("okta-token-storage");
  return (tokensObjectAsStr && JSON.parse(tokensObjectAsStr)?.accessToken) || null;
};

export const oktaIdTokenObject = () => {
  const tokensObjectAsStr = storageProvider.getItem("okta-token-storage");
  return (tokensObjectAsStr && JSON.parse(tokensObjectAsStr)?.idToken) || null;
};

export function getOktaAccessToken() {
  return oktaAccessTokenObject()?.accessToken;
}

export function getOktaIdToken() {
  return oktaIdTokenObject()?.idToken;
}

export function hasOktaTokenExpired() {
  return oktaAccessTokenObject()
    ? oktaAuth.tokenManager.hasExpired(oktaAccessTokenObject())
    : false;
}

export const getUserInfo = () => {
  if (config.isLocalTestEnvironment()) {
    return mockUser;
  }
  const [firstName, lastName] = oktaIdTokenObject()?.claims.name?.split(" ");
  return {
    firstName: firstName,
    lastName: lastName,
    email: oktaIdTokenObject()?.claims.email,
    employeeId: oktaAccessTokenObject()?.claims.emp,
  };
};

export const mockUser = {
  firstName: "Mock",
  lastName: "User",
  email: "mockuser@abc.com",
  employeeId: "11111",
  name: "Mock User",
};

export const logout = async () => {
  return await oktaAuth.signOut();
};

window.getOktaIdToken = getOktaIdToken;
window.getOktaAccessToken = getOktaAccessToken;
